<script setup>
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';
import UazapiWhatsapp from './UazapiWhatsapp.vue';
import ChannelSelector from 'dashboard/components/ChannelSelector.vue';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const PROVIDER_TYPES = {
  WHATSAPP_FACEBOOK: 'whatsapp_facebook',
  WHATSAPP_MANUAL: 'whatsapp_manual',
  WHATSAPP_UAZAPI: 'whatsapp_uazapi',
};

const selectedProvider = computed(() => route.query.provider);
const showProviderSelection = computed(() => !selectedProvider.value);
const showConfiguration = computed(() => Boolean(selectedProvider.value));

const availableProviders = computed(() => [
  {
    key: PROVIDER_TYPES.WHATSAPP_UAZAPI,
    title: 'UaZapi',
    description:
      'Conecte um número WhatsApp via QR Code. Rápido, sem API oficial.',
    icon: 'i-woot-whatsapp',
  },
  {
    key: PROVIDER_TYPES.WHATSAPP_FACEBOOK,
    title: 'Conectar via Facebook',
    description:
      'Configuração automática — conecte sua conta do WhatsApp Business diretamente pelo Facebook.',
    icon: 'i-woot-whatsapp',
  },
  {
    key: PROVIDER_TYPES.WHATSAPP_MANUAL,
    title: 'Configuração manual',
    description:
      'Informe manualmente o Phone Number ID, Business Account ID e API Key.',
    icon: 'i-lucide-settings',
  },
]);

const selectProvider = providerValue => {
  router.push({
    name: route.name,
    params: route.params,
    query: { provider: providerValue },
  });
};
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full">
    <div v-if="showProviderSelection">
      <div class="mb-10 text-left">
        <h1 class="mb-2 text-lg font-medium text-n-slate-12">
          Como deseja conectar?
        </h1>
        <p class="text-sm leading-relaxed text-n-slate-11">
          Escolha entre configuração automática via Facebook, UaZapi ou inserir as
          credenciais manualmente.
        </p>
      </div>

      <div class="flex gap-6 justify-start flex-wrap">
        <ChannelSelector
          v-for="provider in availableProviders"
          :key="provider.key"
          :title="provider.title"
          :description="provider.description"
          :icon="provider.icon"
          @click="selectProvider(provider.key)"
        />
      </div>
    </div>

    <div v-else-if="showConfiguration">
      <div class="px-6 py-5 rounded-2xl border border-n-weak">
        <UazapiWhatsapp
          v-if="selectedProvider === PROVIDER_TYPES.WHATSAPP_UAZAPI"
        />

        <WhatsappEmbeddedSignup
          v-else-if="selectedProvider === PROVIDER_TYPES.WHATSAPP_FACEBOOK"
        />

        <CloudWhatsapp v-else />
      </div>
    </div>
  </div>
</template>
